import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import FormatterCommon from './formatter-common';

    

    function KPIMultiCellFormatter(params, observableOptions, dataSources) {
        var self = this;
        self.observableOptions = observableOptions;
        self.sourcetype = params && params.type ? params.type : "";
        self.observableParams = dataSources[0].observableParams;
        self.observableFormattedData = ko.observable({});
        self.subscriptions = [];
    }

    function FindColumnOption(name, columnOptions) {
        var result = null;
        for (var i = 0; i < columnOptions.length; i++) {
            if (columnOptions[i].name === name) {
                result = columnOptions[i];
                break;
            }
        }
        return result;
    }

    function GetWidths(options) {
        var widths = [];

        var widthRatios = [];
        var sum = 0;
        for (var i = 0; i < options.display.length; i++) {

            var name = options.display[i];
            var colOption = FindColumnOption(name, options.columnOptions);

            if (colOption && colOption.minWindowWidth && ($(window).width() < colOption.minWindowWidth)) {
                widthRatios.push(0);
            } else {
                if (colOption && colOption.widthRatio) {
                    widthRatios.push(colOption.widthRatio);
                    sum += colOption.widthRatio;
                } else {
                    widthRatios.push(1);
                    sum += 1;
                }
            }
        }

        if (sum === 0) {
            sum = 1;
        }

        for (var j = 0; j < widthRatios.length; j++) {
            var widthval = 96 * widthRatios[j] / sum;
            widths.push((widthval) + '%');
        }

        return widths;
    }

    function GetHeaders(display, columnOptions) {
        var headers = [];
        for (var i = 0; i < display.length; i++) {
            var name = display[i];
            var colOption = FindColumnOption(name, columnOptions);

            if (colOption && colOption.title) {
                headers.push(colOption.title);
            } else {
                headers.push(name);
            }
        }
        return headers;
    }

    function ComposeData(sourcetype, sourcelist, options) {
        if (_.isEmpty(_.get(options, 'display'))) {
            return {
                cells: []
            };
        }
        else if (_.isEmpty(sourcelist)) {
            sourcelist = [{}];
        }

        var cells = [];
        var item = sourcelist[0];

        var labels = GetHeaders(options.display, options.columnOptions);
        var widths = GetWidths(options);

        for (var i = 0; i < options.display.length; i++) {
            var rawValue = item[options.display[i]];
            cells.push({
                value: FormatterCommon.getFormattedNumber(rawValue, false /*useAbbreviation*/),
                abbreviatedValue: FormatterCommon.getFormattedNumber(rawValue, true /*useAbbreviation*/),
                footer: labels[i],
                tooltip: labels[i],
                cellclass: "description-block border-right",
                cellwidthclass: "inline-block multicellcell",
                change: null,
                changeiconclass: null,
                cellwidthpct: widths[i]
            });
        }
        return {
            cells: cells
        };
    }

    KPIMultiCellFormatter.prototype.RefreshData = function () {
        var self = this;

        self.sourceList = self.dataRepository.getDictionaryValue(self.dataRepository.QueryResultDictionary, self.observableParams());

        if (self.sourceList !== null) {
            self.observableFormattedData(ComposeData(self.sourcetype, self.sourceList, self.observableOptions()));
        }
    };

    KPIMultiCellFormatter.prototype.LoadFromCache = function (params, context) {
        var self = context;
        var sourceList = self.dataRepository.getDictionaryValue(self.dataRepository.QueryResultDictionary, params);

        if (sourceList === null) {
            return false;
        }

        self.observableFormattedData(ComposeData(
            self.sourcetype,
            sourceList,
            self.observableOptions()));

        return true;
    };

    KPIMultiCellFormatter.prototype.initialize = function (dataRepository) {
        var self = this;

        self.dataRepository = dataRepository;

        self.subscriptions.push(self.dataRepository.QueryResultDictionary.subscribe(self.RefreshData.bind(self)));
        self.subscriptions.push(self.observableOptions.subscribe(self.RefreshData.bind(self)));

        self.observableFormattedData({ loadFromCacheCallback: self.LoadFromCache, context: self });
    };


    KPIMultiCellFormatter.prototype.getObservableData = function () {
        var self = this;
        return self.observableFormattedData;
    };

    KPIMultiCellFormatter.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default KPIMultiCellFormatter;
